/**
 * Is this page being rendered by the build-time prerenderer rather than by a
 * real visitor?
 *
 * The puppeteer renderer sets `window.__PRERENDER_INJECTED` via
 * `evaluateOnNewDocument` before any application code runs (see the `inject`
 * option in vite.config.ts), so the marker is present from the first line of
 * our bundle and is never serialised into the snapshot. A real browser can
 * therefore never report true here.
 *
 * Four places behave differently under the prerenderer:
 * - main.tsx dispatches the readiness event that decides when the snapshot is
 *   taken;
 * - __root.tsx does not load Google Analytics, so the gtag.js script is never
 *   appended to the head and therefore never serialised into the snapshot -
 *   which is how it ended up in the SPA fallback served on every portal page;
 * - status.tsx skips its API calls, so neither a failure nor a live reading is
 *   baked into the served HTML;
 * - chunkReload.ts must not reload the page (the dist is immutable mid-build,
 *   and a reload lands between readiness and snapshot). It deliberately keeps
 *   its own inline check rather than calling this helper, because it reads the
 *   `target` window passed to it - which its tests fake - not the global one.
 */
export function isPrerendering(): boolean {
  return (
    typeof window !== "undefined" &&
    Boolean((window as { __PRERENDER_INJECTED?: unknown }).__PRERENDER_INJECTED)
  );
}
